import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import './Header.css';

const Header = ({ onSearchChange, onCategoryChange, activeCategory, activeSubCategory, searchTerm }) => {
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [categories, setCategories] = useState(() => {
    try {
      const cached = localStorage.getItem("cachedCategories");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/categorias`);
        const allowedSlugsOrIds = [
          'medicamentos', 
          'suplementos', 
          'higiene-pessoal', 
          'dermocosmticos', 
          'bebe', 
          'bebes', 
          'equipamentos', 
          'petshop', 
          'pet-shop', 
          'saude', 
          'beleza-e-cuidado-pessoal', 
          'esportes-e-fitness'
        ];
        const filteredCategories = response.data.filter(cat => 
          allowedSlugsOrIds.includes(cat.slug) || allowedSlugsOrIds.includes(cat.id)
        );
        setCategories(filteredCategories);
        try {
          localStorage.setItem("cachedCategories", JSON.stringify(filteredCategories));
        } catch (e) {
          console.error("Erro ao gravar cache de categorias:", e);
        }
      } catch (error) {
        console.error("Erro ao buscar categorias:", error);
      }
    };
    fetchCategories();
  }, []);



  const handleSearch = (e) => {
    onSearchChange(e.target.value);
    if (location.pathname !== '/') {
      navigate('/');
    }
  };

  const handleLogoClick = () => {
    // Força o recarregamento voltando para a Home
    window.location.href = '/';
  };

  const activeCategoryObj = categories.find(cat => {
    const normalize = str => (str || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalize(cat.name) === normalize(activeCategory);
  });

  return (
    <header style={{ 
      backgroundColor: 'var(--background-white)', 
      borderBottom: '1px solid var(--border-color)', 
      position: 'sticky', 
      top: 0, 
      zIndex: 2100,
      boxShadow: 'var(--shadow-sm)'
    }}>
      <div className="container">
        <div className="header-container">
          {/* Logo */}
          <div
            onClick={handleLogoClick}
            className="header-logo"
          >
            <img src="/logo-otyma.png" alt="Otyma Farma" />
          </div>

          {/* Search Bar */}
          <div className="header-search">
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              backgroundColor: 'var(--background-white)', 
              borderRadius: 'var(--radius-lg)', 
              padding: '6px 16px', 
              boxShadow: 'var(--shadow-sm)',
              border: '1.5px solid var(--border-color)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--primary-color)'}
            onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--border-color)'}
            >
              <input
                type="text"
                placeholder="Procure medicamentos, itens de higiene e muito mais..."
                value={searchTerm || ""}
                onChange={handleSearch}
                style={{ 
                  border: 'none', 
                  outline: 'none', 
                  width: '100%', 
                  fontSize: '14px', 
                  color: 'var(--text-primary)',
                  fontWeight: '500',
                  background: 'transparent'
                }}
              />
              <i className="fas fa-search" style={{ color: 'var(--primary-color)', fontSize: '18px', marginLeft: '10px', cursor: 'pointer' }}></i>
            </div>
          </div>

          {/* User Actions */}
          <div className="header-actions">
            <Link to="/favoritos" style={{ color: 'var(--accent-color)', fontSize: '20px' }}>
              <i className="far fa-heart"></i>
            </Link>
          </div>
        </div>

        {/* Categories - Dropdown Menu */}
        <div style={{ position: 'relative', marginTop: '0' }}>
          <div className="categories-container">

            
            {/* Main Categories (First 8) */}
            {categories.slice(0, 8).map((cat) => (
              <div
                key={cat.id}
                className="category-item"
                onMouseEnter={() => setHoveredCategory(cat.id)}
                onMouseLeave={() => setHoveredCategory(null)}
                style={{ position: 'relative' }}
              >
                <button
                  onClick={() => onCategoryChange(cat.name, null)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: activeCategory === cat.name ? 'var(--primary-color)' : 'var(--text-secondary)',
                    fontWeight: activeCategory === cat.name ? '700' : '600',
                    fontFamily: 'var(--font-title)',
                    fontSize: '13px',
                    cursor: 'pointer',
                    padding: '4px 0',
                    borderBottom: activeCategory === cat.name ? '2px solid var(--primary-color)' : '2px solid transparent',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                  onMouseEnter={(e) => {
                    if (activeCategory !== cat.name) e.currentTarget.style.color = 'var(--primary-color)';
                  }}
                  onMouseLeave={(e) => {
                    if (activeCategory !== cat.name) e.currentTarget.style.color = 'var(--text-secondary)';
                  }}
                >
                  {cat.name} {cat.subcategories && cat.subcategories.length > 0 && <i className="fas fa-chevron-down" style={{ fontSize: '9px', opacity: 0.7 }}></i>}
                </button>

                {/* Subcategories Dropdown */}
                {hoveredCategory === cat.id && cat.subcategories && cat.subcategories.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    backgroundColor: 'white',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    borderRadius: '8px',
                    padding: '12px',
                    zIndex: 1000,
                    minWidth: '220px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    border: '1px solid rgba(0,0,0,0.08)'
                  }}>
                    {cat.subcategories.map((sub) => (
                      <button
                        key={sub.id}
                        onClick={() => {
                          onCategoryChange(cat.name, sub.name);
                          setHoveredCategory(null);
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          textAlign: 'left',
                          padding: '10px 14px',
                          color: '#444',
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          borderRadius: '6px',
                          transition: 'all 0.2s',
                          width: '100%'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#f8f9fa';
                          e.target.style.color = 'var(--primary-color)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.color = '#444';
                        }}
                      >
                        {sub.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {/* "Mais Categorias" Dropdown */}
            {categories.length > 8 && (
              <div
                onMouseEnter={() => setHoveredCategory('more')}
                onMouseLeave={() => setHoveredCategory(null)}
                style={{ position: 'relative' }}
              >
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    color: hoveredCategory === 'more' ? '#333' : '#666',
                    fontWeight: hoveredCategory === 'more' ? '700' : '500',
                    fontSize: '13px',
                    cursor: 'pointer',
                    padding: '4px 0',
                    borderBottom: hoveredCategory === 'more' ? '2px solid #333' : '2px solid transparent',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  Mais Categorias <i className="fas fa-chevron-down" style={{ fontSize: '9px', opacity: 0.7 }}></i>
                </button>

                {hoveredCategory === 'more' && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: 'white',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    borderRadius: '8px',
                    padding: '12px',
                    zIndex: 1000,
                    minWidth: '240px',
                    maxHeight: '450px',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    border: '1px solid rgba(0,0,0,0.08)'
                  }}>
                    {categories.slice(8).map((cat) => (
                      <div key={cat.id} style={{ position: 'relative' }}>
                        <button
                          onClick={() => onCategoryChange(cat.name, null)}
                          style={{
                            background: 'none',
                            border: 'none',
                            textAlign: 'left',
                            padding: '10px 14px',
                            color: '#444',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            borderRadius: '6px',
                            transition: 'all 0.2s',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                            e.currentTarget.style.color = 'var(--primary-color)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#444';
                          }}
                        >
                          {cat.name}
                          {cat.subcategories && cat.subcategories.length > 0 && <i className="fas fa-chevron-right" style={{ fontSize: '9px', opacity: 0.5 }}></i>}
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
          {/* Subcategories horizontal bar */}
          {activeCategoryObj && activeCategoryObj.subcategories && activeCategoryObj.subcategories.length > 0 && (
            <div className="subcategories-container" style={{
              display: 'flex',
              gap: '8px',
              padding: '10px 0',
              overflowX: 'auto',
              scrollbarWidth: 'none',
              whiteSpace: 'nowrap',
              borderTop: '1px solid rgba(0,0,0,0.05)',
              marginTop: '4px'
            }}>
              <style>{`
                .subcategories-container::-webkit-scrollbar { display: none; }
              `}</style>
              <button
                onClick={() => onCategoryChange(activeCategory, null)}
                style={{
                  background: !activeSubCategory ? 'var(--primary-color)' : 'rgba(0, 0, 0, 0.04)',
                  color: !activeSubCategory ? '#fff' : 'var(--text-secondary)',
                  border: 'none',
                  borderRadius: '16px',
                  padding: '6px 14px',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.2s'
                }}
              >
                Todas
              </button>
              {activeCategoryObj.subcategories.map((sub) => {
                const isActiveSub = activeSubCategory === sub.name;
                return (
                  <button
                    key={sub.id}
                    onClick={() => onCategoryChange(activeCategory, sub.name)}
                    style={{
                      background: isActiveSub ? 'var(--primary-color)' : 'rgba(0, 0, 0, 0.04)',
                      color: isActiveSub ? '#fff' : 'var(--text-secondary)',
                      border: 'none',
                      borderRadius: '16px',
                      padding: '6px 14px',
                      fontSize: '12px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      transition: 'all 0.2s'
                    }}
                  >
                    {sub.name}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </header >
  );
};

export default Header;
